<template>
  <div id="app">
    <router-view name="top" v-if="$store.state.top" />
    <!-- <router-view name="banner" v-if="$store.state.banner"/> -->
    <div class="container">
      <router-view name="user" v-if="$store.state.user" />
    </div>
    <div class="x-content">
      <!-- <keep-alive>  -->
      <router-view />
      <!-- </keep-alive> -->
    </div>
    <router-view name="footer" v-if="$store.state.footer" />
    <router-view name="floatAd" v-if="$store.state.floatAd" />
    <!-- <router-view name="fixedImg" v-if="$store.state.fixedImg" /> -->
  </div>
</template>

<script>
// 导入组件
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  async created() {
    if (sessionStorage.getItem('SetItem')) {
      let steItem = JSON.parse(sessionStorage.getItem('SetItem'))
      steItem.map((item) => {
        if (item.SetItemID == 1000) {
          this.$store.state.Name = item.Item_Value
        }
      })
    } else {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 12,
        2960, 2900, 6021, 310, 4554,
      ]
      this.$store.dispatch('_getSet', params).then((res) => {
        let steItem = res.data.Data
        sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
        steItem.map((item) => {
          if (item.SetItemID == 1000) {
            this.$store.state.Name = item.Item_Value
          }
        })
      })
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true //再打开
      })
    },
  },
}
</script>
